import { Injectable, EventEmitter } from '@angular/core';
import { UserAgent } from './user-agent';

@Injectable() 
export class SoftwareKeyboard {
    constructor(
        private userAgent : UserAgent
    ) {
        this.init();
    }

    init() {
        if (typeof window === 'undefined')
            return;

        this.originalWidth = window.innerWidth;
        this.originalHeight = window.innerHeight;

        if (this.userAgent.os == 'ios') {
            // iOS does not fire onresize when keyboard is shown/hidden,
            // so there's no way to detect the software keyboard being visible.
            // However, the way the keyboard is handled in iOS makes knowing whether its
            // visible not nearly as important as knowing on Android, so this is a no-op.
        } else {

            window.addEventListener('resize', () => {
                this.check();
            })
        }
    }

    originalWidth = 1920;
    originalHeight = 1080;

    public check() {
        if (typeof window === 'undefined')
            return;
        
        let newWidth = window.innerWidth;
        let newHeight = window.innerHeight;

        if (newWidth == this.originalWidth && newHeight == this.originalHeight)
            return;
            
        if (newWidth == this.originalHeight && newHeight == this.originalWidth) {
            // Orientation change, skip.
        } else {
            let diff = Math.abs(newHeight - this.originalHeight);

            if (newWidth == this.originalWidth && diff > 100) {
                // Keyboard change.
                if (newHeight > this.originalHeight) {
                    // Keyboard hidden
                    this.keyboardChanged.emit(false);
                } else {
                    // Keyboard shown
                    this.keyboardChanged.emit(true);
                }

                this.originalWidth = newWidth;
                this.originalHeight = newHeight;
            }
        }

        // Track our new dimensions

        this.originalWidth = newWidth;
        this.originalHeight = newHeight;
    }

    keyboardChanged : EventEmitter<boolean> = new EventEmitter<boolean>();


}